/**
 * Shared lender catalogue for Settled Loans.
 *
 * `specialist: true` flags lenders that auto-trigger the SPECIALIST_6M
 * email at month-6 (per the Derwent care spec). The same logic is
 * mirrored server-side in `SPECIALIST_LENDERS` (settled_loans.py) so
 * the front-end choice can't drift out of sync with the cadence.
 */
export const LENDERS = [
  // Big 4
  { name: 'CBA',                        group: 'Big 4' },
  { name: 'NAB',                        group: 'Big 4' },
  { name: 'Westpac',                    group: 'Big 4' },
  { name: 'ANZ',                        group: 'Big 4' },

  // Major mainstream
  { name: 'Macquarie',                  group: 'Mainstream' },
  { name: 'ING',                        group: 'Mainstream' },
  { name: 'Bendigo Bank',               group: 'Mainstream' },
  { name: 'Bank of Queensland',         group: 'Mainstream' },
  { name: 'Suncorp',                    group: 'Mainstream' },
  { name: 'AMP',                        group: 'Mainstream' },
  { name: 'Bankwest',                   group: 'Mainstream' },
  { name: 'Heritage Bank',              group: 'Mainstream' },
  { name: 'Beyond Bank',                group: 'Mainstream' },
  { name: 'MyState',                    group: 'Mainstream' },
  { name: 'P&N Bank',                   group: 'Mainstream' },
  { name: 'Newcastle Permanent',        group: 'Mainstream' },
  { name: 'Teachers Mutual',            group: 'Mainstream' },
  { name: 'Bank of Sydney',             group: 'Mainstream' },
  { name: 'Bank of Melbourne',          group: 'Mainstream' },

  // Non-bank mainstream
  { name: 'Athena',                     group: 'Non-bank' },
  { name: 'Tic:Toc',                    group: 'Non-bank' },
  { name: 'Loans.com.au',               group: 'Non-bank' },
  { name: 'Unloan',                     group: 'Non-bank' },

  // Specialist — trigger SPECIALIST_6M at month 6
  { name: 'Bluestone',                  group: 'Specialist', specialist: true },
  { name: 'MA Money',                   group: 'Specialist', specialist: true },
  { name: 'Pepper Money',               group: 'Specialist', specialist: true },
  { name: 'Liberty',                    group: 'Specialist', specialist: true },
  { name: 'La Trobe Financial',         group: 'Specialist', specialist: true },
  { name: 'VMG',                        group: 'Specialist', specialist: true },
  { name: 'Resimac',                    group: 'Specialist', specialist: true },
  { name: 'Firstmac',                   group: 'Specialist', specialist: true },
];

export const LENDER_GROUPS = ['Big 4', 'Mainstream', 'Non-bank', 'Specialist'];

export const isSpecialistLender = (name) => {
  if (!name) return false;
  return LENDERS.some(
    (l) => l.specialist && l.name.toLowerCase() === String(name).trim().toLowerCase()
  );
};
